/* eslint-disable */
import {
	useState, useEffect, useMemo, useCallback
} from 'react';
import {
	parentTabs,
	tabs,
	tableTabsIssuedSummary,
	tableTabsProducedSummary,
	tableTabsDispatchedSummary,
	tableTabsRestaurantIndent,
	subParentTabs,
	tableTabsWastageSummary,
} from '../tabs.constants';
import { useSelector } from 'react-redux';

export const useTableState = (rawData, setSort, setSearch, isNagaCustomer = false) => {
	const [parentTab, setParentTab] = useState(parentTabs[0]);
	const [subParentTab, setSubParentTab] = useState(subParentTabs[parentTabs[0]?.id]?.[0]);
	const [active, setActive] = useState(null);
	const [selectedTab, setSelectedTab] = useState(tabs[0]?.id);
	const [tableTab, setTableTab] = useState('');
	const [mealTabsList, setMealTabsList] = useState([]);
	const shiftList = useSelector((state) => state?.analytics?.SHIFT_LIST);

	useEffect(() => {
		if (!rawData?.length) return;
		const mealTypes = rawData.map((ele) => ele?.mealType);
		const tabData = (shiftList ?? [])?.filter((ele) => mealTypes.includes(ele?.shiftName?.toLowerCase() === 'day' ? 'allDay' : ele?.shiftName?.toLowerCase()));
		const hasDayShift = (shiftList ?? [])?.some((ele) => ele?.shiftName?.toLowerCase() === 'day');
		if (mealTypes.includes('allDay') && !hasDayShift) {
			tabData.push({
				id: -999,
				shiftName: 'All Day',
			});
		}
		setMealTabsList(tabData);
	}, [rawData, shiftList]);

	useEffect(() => {
		if (mealTabsList?.length > 0) {
			setActive(mealTabsList[0]);
		}
	}, [mealTabsList]);

	useEffect(() => {
		switch (parentTab?.id) {
			case 1:
				switch (subParentTab?.id) {
					case 1:
						setTableTab(tableTabsIssuedSummary[0]?.value);
						break;
					case 2:
						setTableTab(tableTabsRestaurantIndent[0]?.value);
						break;
				}
				break;
			case 2:
				setTableTab(tableTabsProducedSummary[0]?.value);
				break;
			case 3:
				setTableTab(tableTabsDispatchedSummary[0]?.value);
				break;
			case 4:
				setTableTab(tableTabsWastageSummary[0]?.value);
				break;
			default:
				break;
		}
	}, [parentTab, subParentTab]);

	const data = useMemo(() => {
		if (parentTab?.id === 4) return rawData;
		if (!rawData?.length || !active) return {};
		const shiftName = active?.shiftName?.toLowerCase()?.replace(/\s/g, '');
		const mealTypeToMatch = shiftName === 'day' || shiftName === 'allday' ? 'allDay' : active?.shiftName?.toLowerCase();
		const currentData = rawData.find((item) => item?.mealType === mealTypeToMatch) || {};
		return currentData;
	}, [rawData, active, parentTab]);

	const handleParentTab = useCallback((tab) => {
		setParentTab(tab);
	}, []);

	const handleSubParentTab = useCallback((tab) => {
		setSubParentTab(tab);
	}, []);

	const handleMealTab = useCallback((tab) => {
		setActive(tab);
	}, []);

	const handleTableTab = useCallback((value) => {
		setSort({});
		setSearch({});
		if (value !== 'rawMaterials') {
			setSelectedTab('weight');
		}
		setTableTab(value);
	}, []);

	const getTabInfo = useCallback(() => {
		// Helper function to filter tabs based on customer and apply correct labels
		const filterAndLabelTabs = (tabs) => {
			return tabs
				.filter(tab => {
					if (!tab.showCustomer) return true;
					if (tab.showCustomer === 'naga') return isNagaCustomer;
					if (tab.showCustomer === 'a2b') return !isNagaCustomer;
					return true;
				})
				.map(tab => ({
					...tab,
					label: !isNagaCustomer && tab.labelA2b ? tab.labelA2b : tab.label
				}));
		};

		const filteredIssuedTabs = filterAndLabelTabs(tableTabsIssuedSummary);
		const filteredProducedTabs = filterAndLabelTabs(tableTabsProducedSummary);

		const tabConfigs = {
			1: {
				1: { tabList: filteredIssuedTabs, activeTabColor: 'bg-yellow-200' },
				2: { tabList: tableTabsRestaurantIndent, activeTabColor: 'bg-yellow-200' },
			},
			2: {
				tabList: filteredProducedTabs, activeTabColor: 'bg-yellow-200',
			},
			3: {
				tabList: tableTabsDispatchedSummary, activeTabColor: 'bg-yellow-200',
			},
			4: {
				tabList: tableTabsWastageSummary, activeTabColor: 'bg-yellow-200',
			},
		};
		const config = parentTab?.id === 1 ? subParentTab?.id === 1 ? tabConfigs[1][1] : tabConfigs[1][2] : tabConfigs[parentTab?.id];
		if (!config) return null;

		return {
			...config,
			tabValue: tableTab,
			handleTabChange: handleTableTab,
		};
	}, [parentTab, tableTab, handleTableTab, subParentTab, isNagaCustomer]);

	const getAvailableTabs = useCallback(() => {
		if ((parentTab?.id === 1 && tableTab === 'rawMaterials') ||
			(parentTab?.id === 2 && tableTab !== 'outlets')) {
			return tabs;
		}
		return tabs.filter((tab) => tab.id !== 'percentage');
	}, [parentTab, tableTab]);

	return {
		parentTab,
		active,
		selectedTab,
		tableTab,
		mealTabsList,
		data,
		setSelectedTab,
		handleParentTab,
		handleMealTab,
		handleTableTab,
		getTabInfo,
		getAvailableTabs,
		subParentTab,
		setSubParentTab,
		handleSubParentTab,
	};
};
